/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 IOS_Expansion_LITE.glb --transform --simplify --ratio 0.5 --draco 
Files: IOS_Expansion_LITE.glb [8.62MB] > C:\Users\eviei\Desktop\MODELOSORION\ios\IOS_Expansion_LITE-transformed.glb [257.48KB] (97%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function ExpansionIOS(pos) {
  const { nodes, materials } = useGLTF('/models/IOS2-transformed.glb')
  return (
    <group position={[pos[0],pos[1],pos[2]-1.2]}  dispose={null} rotation={[0, Math.PI / 2, 0]}>
      <mesh geometry={nodes['20250909_EPCB0048-V01_EXP_BASE_BOARD_Without_Components005'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['20250909_EPCB0048-V01_EXP_BASE_BOARD_Without_Components005_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/IOS2-transformed.glb')
